var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('DefaultHeader'),_vm._v(" "),_c('FloatCustomerService',{ref:"floatCustomerService"}),_vm._v(" "),_c('Account',{ref:"accountRef"}),_vm._v(" "),_c('BrowserValidModal'),_vm._v(" "),_c('nuxt',{attrs:{"keep-alive":"","keep-alive-props":{ include: _vm.includeArr }}}),_vm._v(" "),_c('IndexFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }